// ─────────────────────────────────────────────────────────────────────────────
// walletApi.ts — API para a Carteira Virtual "Ta Feito"
// ─────────────────────────────────────────────────────────────────────────────

const ADMIN_TOKEN = import.meta.env.VITE_ADMIN_TOKEN ?? 'darkage-admin-dev-token';

// ── Player endpoints ────────────────────────────────────────────────────────

export async function fetchWallet(token: string) {
  const res = await fetch('/api/user/wallet', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `HTTP ${res.status}`);
  return res.json();
}

export async function fetchWalletHistory(token: string, limit = 20, skip = 0) {
  const res = await fetch(`/api/user/wallet/history?limit=${limit}&skip=${skip}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `HTTP ${res.status}`);
  return res.json();
}

// ── Admin endpoints ─────────────────────────────────────────────────────────

export async function fetchEconomyOverview() {
  const res = await fetch('/api/admin/economy/overview', {
    headers: { 'Content-Type': 'application/json', 'X-Admin-Token': ADMIN_TOKEN },
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `HTTP ${res.status}`);
  return res.json();
}

export async function fetchUserStatement(userId: string, limit = 50, skip = 0) {
  const res = await fetch(`/api/admin/economy/user/${userId}?limit=${limit}&skip=${skip}`, {
    headers: { 'Content-Type': 'application/json', 'X-Admin-Token': ADMIN_TOKEN },
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `HTTP ${res.status}`);
  return res.json();
}

export async function adjustWallet(userId: string, amount: number, type: 'CREDIT' | 'DEBIT', description: string) {
  const res = await fetch('/api/admin/economy/adjust', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Admin-Token': ADMIN_TOKEN },
    body: JSON.stringify({ user_id: userId, amount, type, description }),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error ?? `HTTP ${res.status}`);
  return res.json();
}
